import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import time from '../helpers/time';
import { handleEnterPress } from '../helpers/util';
import { startCall } from '../reducers/calls';
import { combinedContactsSelector, combinedEndpointsSelector, contactNamesByNumberSelector, } from '../selectors/contacts';
import styles from '../styles/historicCall.scss';
import StatusLine from './StatusLine';
import { InboundCallIcon, OutboundCallIcon } from './icons';
const HistoricCall = ({ call }) => {
    const dispatch = useDispatch();
    const endpoints = useSelector(combinedEndpointsSelector);
    const contactsMap = useSelector(contactNamesByNumberSelector);
    const allContacts = useSelector(combinedContactsSelector);
    const hasGrantedAudio = useSelector((state) => state.client.hasGrantedAudio);
    const { scope, direction, to: callTo, callerId, callStarted, outcome, duration, dstEndpoint, } = call;
    // TODO Add the rest of the statuses
    // Answered = ANSWERED
    // Missed = NO_ANSWER, BUSY
    // Failed = FAILED
    // const answered = outcome === 'ANSWERED';
    const failed = outcome === 'FAILED';
    const title = failed ? 'Call Failed' : '';
    const directionIcon = direction === 'IN' ? React.createElement(InboundCallIcon, null) : React.createElement(OutboundCallIcon, null);
    const name = direction === 'IN' ? callerId : callTo;
    let lookedUpName = '';
    let description = '';
    if (scope === 'LOCAL' && direction === 'OUT') {
        // Find the destination in the store of endpoints
        const destinationEndpoint = endpoints.find((e) => {
            return e.id === dstEndpoint;
        });
        if (destinationEndpoint) {
            // If we find it, set the details as they are on that endpoint
            lookedUpName = destinationEndpoint.name;
            description = destinationEndpoint.shortNumber;
        }
        else {
            // If all else fails split the string in the 'to' field
            // into name and shortNumber and display those
            const splitTo = /(.*)\s<(\d{3,4})>/gi.exec(callTo);
            const endpointName = splitTo === null || splitTo === void 0 ? void 0 : splitTo[1];
            const endpointShortNumber = splitTo === null || splitTo === void 0 ? void 0 : splitTo[2];
            lookedUpName = endpointName || '';
            description = endpointShortNumber || '';
        }
    }
    else if (contactsMap) {
        // Look up name in contacts map
        lookedUpName = contactsMap[name];
        // If we find it, set the description as the original number
        description = lookedUpName ? name : '';
    }
    // TODO if callerId and from are different (incoming call) display hidden 'via' option
    // eg call from 01234567890 via Main IVR <301>
    // if (callerId !== callFrom) {
    //   const via = callFrom;
    // }
    const sendCall = (number) => {
        // If there's no number, don't bother
        if (number.length === 0) {
            return;
        }
        // Lookup entered info to see if it matches any known contact
        // If it does, initiate the call with more detailed info
        const found = allContacts.some((c) => {
            // FIXME type guard?
            const contactNumber = c.shortNumber ||
                c.phoneNumber;
            if (contactNumber === number) {
                dispatch(startCall({
                    number: contactNumber,
                    type: c.type,
                    name: c.name,
                    description: contactNumber,
                    email: c.email,
                }));
                return true;
            }
            return false;
        });
        // If not, just send a basic call
        if (!found) {
            dispatch(startCall({ number }));
        }
    };
    const onClick = () => {
        const number = description || name;
        sendCall(number);
    };
    return (React.createElement("li", { className: `${styles.container} ${!hasGrantedAudio && styles.disabled}`, onClick: onClick, onKeyDown: handleEnterPress(onClick), 
        // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
        role: 'button', tabIndex: 0 },
        React.createElement(StatusLine, { text: time.formatTime(callStarted), icon: directionIcon, error: failed, title: title }),
        React.createElement("div", { className: styles.text_container },
            React.createElement("div", { className: styles.detail_container },
                React.createElement("div", { className: styles.name }, lookedUpName || name || 'Anonymous'),
                description ? (React.createElement("div", { className: styles.description }, description)) : ('')),
            React.createElement("div", { className: styles.time_container }, time.duration(duration)))));
};
export default HistoricCall;
